import React, { useRef } from "react";
import { motion, useInView } from "motion/react";
import { staggerContainer, fadeInUp } from "./AnimationVariants";

const answers = [
  {
    problem: "Hours of admin every week",
    answer: "Bookings, check-ins and renewals run themselves.",
    detail: "Members book and cancel in the app; the class list updates itself.",
  },
  {
    problem: "Five apps that don't talk",
    answer: "Classes, programming and payments in one place.",
    detail: "One login for the owner, the coaches and every member.",
  },
  {
    problem: "Chasing late payments",
    answer: "Memberships bill automatically.",
    detail: "Card payments and renewals through Stripe, straight to the gym's account.",
  },
];

export function PainPointsSection() {
  const sectionRef = useRef<HTMLDivElement>(null);
  const isInView = useInView(sectionRef, { once: true, margin: "-100px" });

  return (
    <section
      ref={sectionRef}
      aria-labelledby="why-switch-title"
      className="w-full pt-6 pb-14 md:pt-3 md:pb-16"
    >
      <motion.div
        initial="hidden"
        animate={isInView ? "visible" : "hidden"}
        variants={staggerContainer}
        className="mx-auto max-w-[1400px] w-[calc(100%-2rem)] md:w-[calc(100%-240px)] text-center lg:text-left"
      >
        <motion.p
          variants={fadeInUp}
          className="text-xs leading-none uppercase tracking-[0.12em] text-white/55"
        >
          Why gyms switch
        </motion.p>
        <motion.h2
          id="why-switch-title"
          variants={fadeInUp}
          className="mt-4 text-2xl md:text-3xl font-semibold tracking-tight text-white"
        >
          Less admin. More coaching.
        </motion.h2>

        <ul className="mt-10 md:mt-12 grid grid-cols-1 lg:grid-cols-3 gap-10 lg:gap-12">
          {answers.map((item) => (
            <motion.li key={item.problem} variants={fadeInUp}>
              <p className="text-[15px] text-white/55 line-through decoration-primary/60 decoration-1">
                {item.problem}
              </p>
              <h3 className="mt-2 text-lg font-semibold leading-snug text-white text-balance">
                {item.answer}
              </h3>
              <p className="mt-2 text-sm leading-relaxed text-white/60 text-pretty">
                {item.detail}
              </p>
            </motion.li>
          ))}
        </ul>
      </motion.div>
    </section>
  );
}
